App.config([
    'localStorageServiceProvider',
    function(localStorageServiceProvider) {
        localStorageServiceProvider.setPrefix('rlt:');
    }
]);